import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=0cf9c07f&scoped=true&"
import script from "./UploadDialog.vue?vue&type=script&lang=js&"
export * from "./UploadDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadDialog.vue?vue&type=style&index=0&id=0cf9c07f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9c07f",
  null
  
)

export default component.exports